import QrCode from "../../Assets/images/qrcode.png";
import PlayStore from "../../Assets/images/play_store.svg";
import AppStore from "../../Assets/images/app_store.svg";
import { useTranslation } from "react-i18next";

const DownloadApp = ({ onMouseOver, onMouseOut }) => {
  const { t } = useTranslation();
  return (
    <div
      className="p-8 flex gap-4 bg-white rounded shadow-lg max-w-[26rem]"
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <img
        className="w-36 border-2 border-blue-500 rounded-lg"
        src={QrCode}
        alt=""
      />
      <div className="flex flex-col gap-2 text-center items-center">
        <span>{t("Scan this QR or download app from:")}</span>
        <a
          href="https://play.google.com/store/apps/details?id=com.pajakind.pajakind"
          target="_blank"
          rel="noreferrer"
        >
          <img className="w-28" src={PlayStore} alt="PlayStore" />
        </a>
        <a
          href="https://apps.apple.com/id/app/pajakind/id1533231909?l=id"
          target="_blank"
          rel="noreferrer"
        >
          <img className="w-28" src={AppStore} alt="AppStore" />
        </a>
      </div>
    </div>
  );
};

export default DownloadApp;
